import { Select } from 'antd'

import { useUser } from 'hooks'
import { RiceLotStatus } from 'types'
import { RICE_LOT } from 'consts'

interface Props {
  onChange: (lotStatus: RiceLotStatus) => void
  value?: RiceLotStatus
}

const { Option } = Select

export const SimpleLotStatusSelect: React.FC<Props> = ({ onChange, value }) => {
  const user = useUser()

  const organizationStatusMilestones = user?.organizationRole?.organization?.statusMilestones

  const lotStatusOptions =
    organizationStatusMilestones?.map(status => ({
      label: RICE_LOT.STATUS_NAME_MAP[status],
      value: status,
    })) ?? []

  return (
    <Select
      listHeight={300}
      placeholder="Sin seleccionar..."
      notFoundContent={'No hay coincidencia'}
      value={lotStatusOptions.length ? value : undefined}
      onChange={onChange}
    >
      {lotStatusOptions.map(lotStatus => (
        <Option key={lotStatus.value} value={lotStatus.value}>
          {lotStatus.label}
        </Option>
      ))}
    </Select>
  )
}
